import { DVV_CALL_TYPE, DVV_EVENT_TYPE, WEB_RTC_Constants } from "./Constants";
import shoutUIComponent from "../../../model/shoutUIComponent";
import {preCallInstructionsRender} from "../templates/renders/preCallInstructions";

interface TypeDef_PreCallInstructions extends shoutUIComponent {
    constants?: any;
    renderer: any;
    $app?: any;
    onClickGetStarted: () => void;
}

/**
 * Custom element for display pre video call instructions
 * @type {{template, created(), tagName: string, onCancelClick(): void, onOkClick(): void}}
 */
// eslint-disable-next-line object-shorthand
const PreCallInstructions: TypeDef_PreCallInstructions = {
    tagName: "pre-call-instructions-view",
    renderer: preCallInstructionsRender,
    created(): void {
        const startButton = this.el.querySelector(".pre-call-instructions-footer button");
        startButton.focus();
    },
    onClickGetStarted(): void {
        // removes itself and display device settings page.
        const parentElement = this.el.parentElement;
        const deviceSettingsView = document.createElement("device-settings-view");
        deviceSettingsView.setAttribute(WEB_RTC_Constants.ENABLED_CUSTOMER_CAMERA,
            this.prop[WEB_RTC_Constants.ENABLED_CUSTOMER_CAMERA.toLowerCase()]);
        deviceSettingsView.setAttribute(WEB_RTC_Constants.ENABLED_VOICE_ONLY_CALL,
            this.prop[WEB_RTC_Constants.ENABLED_VOICE_ONLY_CALL.toLowerCase()]);
        parentElement.append(deviceSettingsView);
        parentElement.removeChild(this.el);
        let dvvType = DVV_CALL_TYPE.VIDEO_CALL_ONE_WAY;

        if (this.data.showCustomerCamera) {
            dvvType = DVV_CALL_TYPE.VIDEO_CALL_TWO_WAY;
        } else if (this.data.voiceOnlyCall) {
            dvvType = DVV_CALL_TYPE.VOICE_ONLY;
        }

        this.$app.logWebRTCEvents(DVV_EVENT_TYPE.CUSTOMER_ACCEPTED_CALL_OFFER, dvvType);
    },
};

/**
 * @export
 * @param   {CIApp} appInstance App instance
 * @return  {PreCallInstructions}    View instance
 */
export default (appInstance: any) => {
    const appConfig = appInstance.getUIConfig();
    const callInstructionsProps = appConfig.webRTCProps && appConfig.webRTCProps.preCallInstructionsProps;
    const videoCallProps = callInstructionsProps && callInstructionsProps.videoCall;
    const voiceOnlyCallProps = callInstructionsProps && callInstructionsProps.voiceOnlyCall;
    const customerCameraEnable = WEB_RTC_Constants.ENABLED_CUSTOMER_CAMERA.toLowerCase();
    const voiceOnlyEnable = WEB_RTC_Constants.ENABLED_VOICE_ONLY_CALL.toLowerCase();
    PreCallInstructions.$app = appInstance;

    /**
     * @type {Object}
     */
    const constObj: any = {};

    if (callInstructionsProps) {
        const { disclaimerText, browserSettingPopupText } = callInstructionsProps;
        constObj.disclaimerText = disclaimerText || WEB_RTC_Constants.DISCLAIIMER_TEXT;
        constObj.browserSettingPopupText = browserSettingPopupText || WEB_RTC_Constants.BROWSER_SETTINGS_POPUP_TEXT;
        constObj.browserSettingPopupVoiceText = browserSettingPopupText || WEB_RTC_Constants.BROWSER_SETTINGS_POPUP_VOICE_TEXT;
    }

    PreCallInstructions.data = {
        primaryText: (state: any) => {
            if (state.prop[customerCameraEnable] === "true") {
                const text = videoCallProps && videoCallProps.primaryInstructionText
                    ? videoCallProps.primaryInstructionText : WEB_RTC_Constants.PRE_VIDEO_CALL_PRIMARY_TEXT;
                return text;
            }

            const text = voiceOnlyCallProps && voiceOnlyCallProps.primaryInstructionText
                ? voiceOnlyCallProps.primaryInstructionText : WEB_RTC_Constants.PRE_VOICE_CALL_PRIMARY_TEXT;
            return text;
        },
        secondaryText: (state: any) => {
            if (state.prop[customerCameraEnable] === "true") {
                const text = videoCallProps && videoCallProps.secondaryInstructionText
                    ? videoCallProps.secondaryInstructionText : WEB_RTC_Constants.PRE_VIDEO_CALL_SECONDARY_TEXT;
                return text;
            }

            const text = voiceOnlyCallProps && voiceOnlyCallProps.secondaryInstructionText
                ? voiceOnlyCallProps.secondaryInstructionText : WEB_RTC_Constants.PRE_VOICE_CALL_SECONDARY_TEXT;
            return text;
        },
        headingText: (state: any) => {
            if (state.prop[customerCameraEnable] === "true") {
                const text = videoCallProps && videoCallProps.heading
                    ? videoCallProps.heading : WEB_RTC_Constants.VIDEO_CALL_HEADING;
                return text;
            }

            const text = voiceOnlyCallProps && voiceOnlyCallProps.heading
                ? voiceOnlyCallProps.heading : WEB_RTC_Constants.VOICE_ONLY_CALL_HEADING;
            return text;
        },
        startButtonText: (state: any) => {
            if (state.prop[customerCameraEnable] === "true") {
                const text = videoCallProps && videoCallProps.startButtonText
                    ? videoCallProps.startButtonText : WEB_RTC_Constants.VIDEO_CALL_CHECK_DEVICES_BUTTON_TEXT;
                return text;
            }

            const text = voiceOnlyCallProps && voiceOnlyCallProps.startButtonText
                ? voiceOnlyCallProps.startButtonText : WEB_RTC_Constants.VOICE_ONLY_CALL_CHECK_DEVICES_TEXT;
            return text;
        },
        showCustomerCamera:
            (state: any) => state.prop[customerCameraEnable] === "true",
        voiceOnlyCall:
            (state: any) => state.prop[voiceOnlyEnable] === "true",
    };

    PreCallInstructions.constants = constObj;
    return PreCallInstructions;
};
